import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/account.svg';
const Account = () => React.createElement(IconSvg, null);
export default Account;
